import {combineReducers } from 'redux';
import employeesReducer from './employeesReducer';
import projectsReducer from './projectsReducer';
import projectcategoriesReducer from './projectcategoriesReducer';
import newsReducer from './newsReducer';
import siteReducer from './siteReducer';
import servicesReducer from './servicesReducer';
import pagesReducer from './pagesReducer';

const rootReducer = combineReducers({
    employees: employeesReducer,
    projects: projectsReducer,
    projectcategories: projectcategoriesReducer,
    news: newsReducer,
    site: siteReducer,
    services: servicesReducer,
    pages: pagesReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js